export const KEYS = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    SPACE: 32
};

export const DELIMITER = '***';




// WEBPACK FOOTER //
// ./src/common/tree/constants/keys.ts